<input
    type="text"
    [ngClass]="size"
    [(ngModel)]="viewValue"
    [disabled]="disable"
    autocomplete="off"
    (blur)="onInputBlur()"
/>
